import styled from "styled-components";
import useUserProfile from "../../hooks/profile/useUserProfile";

function UserProfile(){
    const {user, onLogoutClickHandler} = useUserProfile();
    return(
        <Container>
            <TitleWrap>
                <Title>PROFILE</Title>
                <Button onClick={onLogoutClickHandler}>로그아웃</Button>
            </TitleWrap>
            <Content>
                <HorizontalSprator />
                <Name>{user.name}</Name>
                <HorizontalSprator />
                <DataWrap>
                    <DataWithLabel>
                        <Label>아이디</Label>
                        <Data>{user.id}</Data>
                    </DataWithLabel>
                    <DataWithLabel>
                        <Label>전화번호</Label>
                        <Data>{user.tel}</Data>
                    </DataWithLabel>
                </DataWrap>
                <HorizontalSprator />
            </Content>
        </Container>
    )
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding: 30px;
    gap: 20px;
    border-radius: 20px;
    background-color: #EBEBEB;
`

const TitleWrap = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 10px;
    padding-left: 30px;
    padding-right: 30px;
`

const Title = styled.div`
    color: #222;
    font-size: 20px;
    font-weight: 550;
`

const Content = styled.div`
    display: flex;
    flex-direction: column;
    gap: 40px;
`

const Name = styled.div`
    color: #222;
    font-size: 20px;
    font-weight: 550;
    padding-left: 30px;
    padding-right: 30px;
`

const DataWrap = styled.div`
    padding-left: 30px;
    padding-right: 30px;
    display: flex;
    flex-direction: column;
    gap: 10px;
`

const DataWithLabel = styled.div`
    display: flex;
    gap: 20px;
    font-size: 16px;
`

const Label = styled.div`
    color: #838383;
`

const Data = styled.div`
    color: #222;
`


const HorizontalSprator = styled.div`
    background-color: #58AC65;
    height: 1px;
`

const Button = styled.button`
    background: #007912;
    border-radius: 12px;
    border: none;
    padding:12px;
    color: #FFF;
    font-size: 16px;
    font-weight: 700;
    cursor: pointer;
`

export default UserProfile;